export const keys = {
	campusId: "campusId",
	studentId: "studentId",
	reloadEnrollmentSelector: "reloadEnrollmentSelector",
	leadId: "leadId"
};
